import { render, staticRenderFns } from "./supplierLedger.vue?vue&type=template&id=4fc4a0b4&scoped=true"
import script from "./supplierLedger.vue?vue&type=script&lang=js"
export * from "./supplierLedger.vue?vue&type=script&lang=js"
import style0 from "./supplierLedger.vue?vue&type=style&index=0&id=4fc4a0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4a0b4",
  null
  
)

export default component.exports